import { atom } from 'recoil';

export const notificationFilterState = atom({
    key: 'notificationFilterState',
    default: [] as any[],
  });